import audio from '@/scripts/audio';
import gsap from 'gsap';
import { Loader, Point, Sprite } from 'pixi.js';
import ticker from '../ticker';
import { hitTest } from '../utils';
import Actor from './Actor';

class Jump extends Actor {
  constructor(parent, player) {
    super(parent);
    this.player = player;
    this.catched = false;

    this.sprite = new Sprite();
    this.jump = new Sprite(Loader.shared.resources['textures/JUMP'].texture);
    this.shadow = new Sprite(Loader.shared.resources['textures/JUMP_SHADOW'].texture);

    this.frameHandler = () => { this.frame(); };

    this.resize();
    this.sprite.addChild(this.jump);
    this.sprite.addChild(this.shadow);
    this.parent.addChild(this.sprite);

    ticker.add(this.frameHandler);

    this.timeline = gsap.timeline({ repeat: -1, yoyo: true })
      .addLabel('start')
      .to(this.jump.position, { y: -15, ease: 'power2.inOut', duration: 1 }, 'start')
      .to(this.shadow.scale, { x: 0.6, ease: 'power2.inOut', duration: 1 }, 'start');
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.jump.anchor = new Point(0.5, 0.5);
    this.shadow.anchor = new Point(0.5, 0.5);
    this.shadow.position.y = this.jump.height;
  }

  frame() {
    if (hitTest(this.sprite, this.player.sprite) && !this.catched && !this.player.jumping && !this.player.isButterfly) {
      this.catched = true;
      this.player.jumping = true;
      audio.play('jump');
      // this.player.interaction.stop();
      const { position } = this.player.sprite;

      gsap.timeline({ defaults: { duration: 0.6 } })
        .addLabel('start')
        .to(this.player.tail.sprite.scale, {
          x: 1.4,
          y: 1.4,
          ease: 'power2.out',
        }, 'start')
        .to(this.player.tail.sprite.position, {
          x: `-=${position.x * 0.4}`,
          y: `-=${position.y * 0.4}`,
          ease: 'power2.out',
        }, 'start')
        .to(this.player.tail.shadow, {
          distance: 15,
          alpha: 0.3,
          ease: 'power2.out',
        }, 'start')
        .addLabel('mid')
        .to(this.player.tail.sprite.scale, {
          x: 1,
          y: 1,
          ease: 'power2.in',
        }, 'mid')
        .to(this.player.tail.sprite.position, {
          x: 0,
          y: 0,
          ease: 'power2.in',
        }, 'mid')
        .to(this.player.tail.shadow, {
          distance: 2,
          alpha: 0.7,
          ease: 'power2.out',
        }, 'mid')
        .call(() => {
          audio.play('ending');
          this.player.jumping = false;
          // this.player.interaction.start();
        });
    }
  }

  destroy() {
    ticker.remove(this.frameHandler);
  }
}

export default Jump;
